import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import { CookiesProvider } from 'react-cookie';
import { datadogRum } from "@datadog/browser-rum";
import {isUndefined} from 'lodash';
import configureStore, { history } from "./store/configureStore";
import App from "./App";

if (!isUndefined(process.env.REACT_APP_DD_CLIENT_TOKEN)) {
  datadogRum.init({
    applicationId: process.env.REACT_APP_DD_APP_ID,
    clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
    service: process.env.REACT_APP_DD_SERVICE,
    version: process.env.REACT_APP_VERSION,
    env: process.env.REACT_APP_ENV,
    sampleRate: process.env.REACT_APP_ENV === 'production' ? 100 : 0,
    sessionReplaySampleRate: process.env.REACT_APP_ENV === 'production' ? 100 : 0,
    trackInteractions: true,
    trackLongTasks: true,
    trackResources: true,
    trackSessionAcrossSubdomains: true,
    useSecureSessionCookie: true,
    allowedTracingOrigins: [/https:\/\/.*\.firstcircle\.(ph|com|io)/],
  });

  // Start recording DataDog Session Replay
  datadogRum.startSessionReplayRecording();
}

const store = configureStore();

ReactDOM.render(
  (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <CookiesProvider>
          {/* NOTE: Please don't remove or rename the class ds-container. */}
          {/* This is very important because we are using it to check if our design system's loaded and ready. */}
          {/* You can check withDesignSystemLoader.js for the implementation details about this. */}
          <div className="index-container ds-container">
            <App />
          </div>
        </CookiesProvider>
      </ConnectedRouter>
    </Provider>
  ),
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js